import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.5 12a7.5 7.5 0 1 0 2.27-5.375h1.605a.75.75 0 0 1 0 1.5h-3.25a.75.75 0 0 1-.75-.75v-3.25a.75.75 0 0 1 1.5 0v1.28a9 9 0 1 1-2.842 5.82c.036-.42.401-.725.824-.725.41 0 .715.377.676.785A7.661 7.661 0 0 0 4.5 12Zm8-4.25a.75.75 0 1 0-1.5 0v5a.75.75 0 0 0 .75.75h2.5a.75.75 0 1 0 0-1.5H12.5V7.75Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render };